export function BankingSettingsPage () {
  return (
    <div className='p-6'>
      <h2 className='heading-md'>Banking</h2>
    </div>
  )
}
